import './SurveySendTable.less'

import { Box } from 'front-end/src/components/'
import TableExtendedOld from 'front-end/src/components/common/table-extended-old/TableExtendedOld'
import { formatDateShort } from 'front-end/src/utils/dateHelpers'
import React from 'react'
import { Column } from 'react-table'

import { Plural, t, Trans } from '@lingui/macro'

import { brandColors } from '../../../../../../shared/basicPalette'
import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import Tag from '../../../../components/common/tag/Tag'
import UserDetail from '../../../../components/common/user/user-detail/UserDetail'
import {
  SqlOrderDirectionEnum,
  SurveyManageUsersOverviewOrderColumn
} from '../../../../graphql/private/PrivateSchemaTypes'
import { SurveyParticipantsContext } from './WithSurveyParticipantsContext'
import { ResendSurveyButton } from './ResendSurveyButton'

const SurveySendTable = () => {
  const { loading, survey, tableFilters, changeFilter, refetchUsers } =
    React.useContext(SurveyParticipantsContext)

  const usersCount = survey?.participantsCount || 0
  const surveyParticipants = survey?.participants || []

  const tableColumns: Column[] = [
    {
      Header: t`User`,
      accessor: 'display_name',
      Cell: (row) => {
        return (
          <UserDetail
            display_name={row.original.user.display_name}
            imageUrl={row.original.user.image_url}
            meta={row.original.user.userIdentity}
            size={'normal'}
            onClick={() =>
              navigateTo(linkBuilder.userDetail(row.original.user.id))
            }
          />
        )
      }
    },
    {
      Header: t`Sent`,
      accessor: 'created_at',
      maxWidth: 165,
      className: 'center',
      headerClassName: 'center',
      Cell: (row) => formatDateShort(row.original.created_at)
    },
    {
      Header: t`Opened`,
      accessor: 'started_at',
      maxWidth: 165,
      className: 'center',
      headerClassName: 'center',
      Cell: (row) => <ResendSurveyButton row={row} />
    },
    {
      Header: t`Responded`,
      accessor: 'completed_at',
      maxWidth: 165,
      className: 'center',
      headerClassName: 'center',
      Cell: (row) =>
        row.original.completed_at && formatDateShort(row.original.completed_at)
    },
    {
      Header: t`Status`,
      className: 'center tags',
      headerClassName: 'center',
      sortable: false,
      maxWidth: 165,
      minWidth: 110,
      Cell: (row) => {
        if (row.original.completed_at) {
          return (
            <Tag color="green">
              <Trans>Completed</Trans>
            </Tag>
          )
        } else if (row.original.started_at) {
          return (
            <Tag color="blue">
              <Trans>Opened</Trans>
            </Tag>
          )
        } else {
          return (
            <Tag color="clear">
              <Trans>Sent</Trans>
            </Tag>
          )
        }
      }
    }
  ]

  return (
    <div className="SurveySend__table">
      <header className="SurveySend__header" />
      <TableExtendedOld
        showSearchFilter
        manual
        loading={loading}
        onSearchChange={(value) => {
          changeFilter({
            search: value
          })
        }}
        data={surveyParticipants}
        noDataText={t`No recipients added yet`}
        columns={tableColumns}
        className="-highlight SurveySend"
        minRows={5}
        pages={Math.ceil(usersCount / tableFilters.limit)}
        page={tableFilters.page}
        onPageChange={(newPage) => {
          changeFilter({ page: newPage })
          refetchUsers()
        }}
        sortable={true}
        defaultPageSize={tableFilters.limit}
        defaultSorted={[
          {
            id: tableFilters.order,
            desc: tableFilters.orderDirection === SqlOrderDirectionEnum.DESC
          }
        ]}
        onSortedChange={(newSorted) => {
          const descendingOrder = newSorted[0] ? newSorted[0].desc : false
          changeFilter({
            order: newSorted[0]
              ? (newSorted[0].id as SurveyManageUsersOverviewOrderColumn)
              : SurveyManageUsersOverviewOrderColumn.display_name,
            orderDirection: descendingOrder
              ? SqlOrderDirectionEnum.DESC
              : SqlOrderDirectionEnum.ASC
          })
        }}
      />
      <Box mt="12px" pl="28px" color={brandColors.grey.mid}>
        <Plural
          value={usersCount}
          _0={null}
          one={`# recipient`}
          other={`# recipients`}
        />
      </Box>
    </div>
  )
}

export default SurveySendTable
